import React from "react";
import useStyles from "./FmUpdateNpk.style";
import { useTranslation } from "react-i18next";

interface FmUpdateNpkProps {
  onUpdate: () => void;
}

const FmUpdateNpk = ({ onUpdate }: FmUpdateNpkProps) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.container} onClick={onUpdate}>
      <img src={"/multi-match/assets/update.png"} />
      <span className={classes.updateText}> {t("pageStep5.updateButton")}</span>
    </div>
  );
};

export default FmUpdateNpk;
